import { SharedProps, useSnackbar } from 'notistack';
import React, { useEffect, useState } from 'react';
import { Trans } from 'react-i18next';

import { CONSTANTS } from '../core/config/constants';

export function useSnackbarMessage<T>(
  open: boolean,
  message: string,
  props?: SharedProps,
  count?: number,
) {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const [key, setKey] = useState<any>();

  useEffect(() => {
    if (open) {
      if (props?.variant === CONSTANTS.ERROR) {
        closeSnackbar(key);
      }

      const keySnackbar = enqueueSnackbar(<Trans i18nKey={message} count={count} />, props);
      if (props?.variant !== CONSTANTS.ERROR) {
        setKey(keySnackbar);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);
}
